import { useState } from "react";
import { Popover, Button } from "antd";
import styles from "./custom-popover.module.css";

const CustomPopover = ({
  children,
  message = "Are you sure?",
  confirmText = "Yes",
  cancelText = "No",
  onConfirm,
  onCancel,
  popoverProps = {},
  style = {},
  className = "",
}) => {
  const [open, setOpen] = useState(false);

  const handleConfirm = () => {
    setOpen(false);
    onConfirm?.();
  };

  const handleCancel = () => {
    setOpen(false);
    onCancel?.();
  };

  const content = (
    <div className={styles.popoverContent}>
      <p>{message}</p>
      <div className={styles.popoverButtons}>
        <Button size="small" onClick={handleCancel}>
          {cancelText}
        </Button>
        <Button size="small" danger onClick={handleConfirm}>
          {confirmText}
        </Button>
      </div>
    </div>
  );

  return (
    <Popover
      content={content}
      trigger="click"
      open={open}
      onOpenChange={(visible) => setOpen(visible)}
      {...popoverProps}
    >
      <div
        className={className}
        style={{ display: "inline-block", cursor: "pointer", ...style }}
        onClick={(e) => {
          e.stopPropagation();
          setOpen(true);
        }}
      >
        {children}
      </div>
    </Popover>
  );
};

export default CustomPopover;
